// extracted by mini-css-extract-plugin
export default {"container":"overview-event_container__BbMoI"};